<template>
  <div>
    <search-bar/>
    <section id="list-products">
      <product-item/>
      <nav id="page-number">
        <ul class="pagination mx-auto">
          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page == currentPage }"
          >
            <span
              @click="changePage(page)"
              class="page-link"
              href="#"
              :aria-current="currentPage"
            >
              {{ page }}
            </span>
          </li>
        </ul>
      </nav>
    </section>
  </div>
</template>

<script>
import SearchBar from "./SearchBar.vue";
import ProductItem from "./ProductItem.vue"
import Swal from 'sweetalert2'


export default {
  name: "ProductList",
  components: {
    SearchBar,
    ProductItem
  },
  computed: {
    products() {
      return this.$store.state.products;
    },
    currentPage() {
      return this.$store.state.currentPage;
    },
    totalPages() {
      return this.$store.state.totalPages;
    },
  },
  methods: {
    changePage(selectedPage) {
     
      this.$store.commit("CHANGE_PAGE",  selectedPage );
      this.$store.dispatch("fetchProducts");
    },
    bookmarkProduct(id){
      
      this.$store.commit("BOOKMARK_PRODUCT", id)
      this.$store.dispatch("bookmarkProduct")
        .then(response => {
          Swal.fire('Success Add Product to Bookmark')
          console.log(response);

          this.$router.push({name : "BookmarkPage"})
        })
        .catch(err => {
          console.log(err.response);
        })
    },
    detailProduct(id){
 
      // this.$router.push({name : "DetailPage"})
      this.$router.push(`/customers/detailpage/${id}`)
    }
  },
  created() {
    this.$store.commit('CLEAR_SEARCH')
    this.$store.dispatch("fetchProducts");
  },
};
</script>

<style>
span {
  cursor: pointer;
}
</style>
